import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function Explore() {
  const navigate = useNavigate();
  const [tools, setTools] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => { api.get("/tools").then(({ data }) => setTools(data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(tools.map((t) => t.category)))];
  const shown = active === "All" ? tools : tools.filter((t) => t.category === active);

  return (
    <div className="mx-auto max-w-6xl px-5 pt-8 md:pt-12">
      <h1 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">Explore all tools</h1>
      <p className="mt-2 text-muted-foreground">Pick a question and get a personalized, reflective reading.</p>

      <div className="no-scrollbar mt-6 flex gap-2 overflow-x-auto pb-1">
        {cats.map((c) => (
          <button key={c} data-testid={`explore-cat-${c}`} onClick={() => setActive(c)}
            className={`shrink-0 rounded-full border px-4 py-1.5 text-sm btn-lift ${active === c ? "bg-foreground text-background" : "bg-card"}`}>{c}</button>
        ))}
      </div>

      <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {shown.map((t, i) => (
          <button key={t.id} data-testid={`explore-tool-${t.id}`} onClick={() => navigate(`/ask/${t.id}`)}
            style={{ animationDelay: `${i * 50}ms` }}
            className="card-soft fade-up flex flex-col items-start gap-2 rounded-2xl p-6 text-left btn-lift">
            <span className="text-3xl">{t.emoji}</span>
            <span className="font-display text-lg font-semibold">{t.question}</span>
            <span className="text-sm text-muted-foreground">{t.description}</span>
            <span className="mt-2 inline-flex items-center gap-1 text-sm font-medium gold-text">From ₹{t.price} <ArrowRight className="h-3.5 w-3.5" /></span>
          </button>
        ))}
      </div>
    </div>
  );
}
